/* eslint-disable @stylistic/max-len */
import type {RefObject} from 'react';

/**
 * The `ExploreIconProps` interface defines the properties for the ExploreIcon component.
 */
interface ExploreIconProps {
    /** CSS class to override default styling. */
    className?: string;
    /** Primary color of the icon. */
    color1?: string;
    /** Height of the icon. */
    height?: number | string;
    ref?: RefObject<SVGSVGElement>;
    /** Test ID for Cypress. */
    testId?: string;
    /** Width of the icon. */
    width?: number | string;
}

/**
 * Material Symbol "explore" — outlined, weight 300.
 * Compass icon for the Explore/Discover navigation tab.
 *
 * @param props           The component props.
 * @param props.className CSS class override.
 * @param props.color1    Primary icon color.
 * @param props.height    Icon height.
 * @param props.ref       SVG element ref.
 * @param props.testId    Test identifier.
 * @param props.width     Icon width.
 * @returns A React SVG element.
 */
export const ExploreIcon = ({
    className = '',
    color1 = 'currentColor',
    height,
    ref,
    testId = 'ExploreIcon',
    width
}: ExploreIconProps) => (
    <svg
        ref={ref}
        className={className}
        data-cy={testId}
        fill={color1}
        height={height}
        viewBox="0 -960 960 960"
        width={width}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="m313.08-313.08 256.15-77.69 77.69-256.15-256.15 77.69-77.69 256.15Zm166.83-114.61q-21.83 0-37.02-15.29-15.2-15.28-15.2-37.11t15.29-37.02q15.28-15.2 37.11-15.2t37.02 15.29q15.2 15.28 15.2 37.11t-15.29 37.02q-15.28 15.2-37.11 15.2Zm.16 327.69q-78.84 0-148.21-29.92t-120.68-81.21q-51.31-51.29-81.25-120.63Q100-401.1 100-479.93q0-78.84 29.92-148.21t81.21-120.68q51.29-51.31 120.63-81.25Q401.1-860 479.93-860q78.84 0 148.21 29.92t120.68 81.21q51.31 51.29 81.25 120.63Q860-558.9 860-480.07q0 78.84-29.92 148.21t-81.21 120.68q-51.29 51.31-120.63 81.25Q558.9-100 480.07-100Zm-.07-60q133.38 0 226.69-93.31T800-480q0-133.38-93.31-226.69T480-800q-133.38 0-226.69 93.31T160-480q0 133.38 93.31 226.69T480-160Zm0-320Z" />
    </svg>
);

ExploreIcon.displayName = 'ExploreIcon';